module.exports = __webpack_public_path__ + "img/F3F2.7b0161d2.jpg";